import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import productReducer from "./productSlice";
import cartReducer, { persistCart } from "./cartSlice";
import ordersReducer from "./ordersSlice";

export const store = configureStore({
  reducer: { auth: authReducer, products: productReducer, cart: cartReducer, orders: ordersReducer },
  middleware: (getDefault) => getDefault({ serializableCheck: false }),
});

let lastItems = store.getState().cart.items;
store.subscribe(() => {
  const items = store.getState().cart.items;
  if (items !== lastItems) { lastItems = items; persistCart(items); }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
